import { getAuth } from "services/identity.service";
const auth = getAuth();
let role = auth ? auth.role : "";
let leftNavigation = {
  "USER CONTROL": [
    {
      order: 1,
      name: "Admin Control",
      expanded: false,
      icon: <i className="bx bx-grid-alt"></i>,
      children: [
        {
          order: 1,
          name: "Users",
          route: "/members",
          role: ["super_admin"],
        },
      ],
    },
  ],
  MENU: [
    {
      order: 1,
      name: "Women's Wear",
      icon: <i className="bx bx-store"></i>,
      children: [
        {
          order: 1,
          name: "Main Banners",
          route: "/womens-wear/banners",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Announcement Bar",
          route: "/womens-wear/announcement-bar",
          role: ["super_admin", "admin"],
        },
        {
          order: 3,
          name: "Categories",
          route: "/womens-wear/categories",
          role: ["super_admin", "admin"],
        },
        {
          order: 4,
          name: "Secondary Widgets",
          children: [
            {
              order: 1,
              name: "Secondary Widget-1",
              route: "/womens-wear/secondaryWidgetOne",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "Secondary Widget-2",
              route: "/womens-wear/secondaryWidgetTwo",
              role: ["super_admin", "admin"],
            },
          ],
        },
        {
          order: 2,
          name: "Deal Widget",
          route: "/womens-wear/deal-widget",
          role: ["super_admin", "admin"],
        },
        {
          order: 3,
          name: "Sections",
          route: "/womens-wear/sections",
          role: ["super_admin", "admin"],
        },
        {
          order: 3,
          name: "Product Card",
          children: [
            {
              order: 1,
              name: "Show Percentage Off",
              route: "/show-percentage-off",
              role: ["super_admin", "admin"],
            }
          ]
        },
        {
          order: 3,
          name: "Product Detail Page",
          children: [
            {
              order: 1,
              name: "Sections",
              children: [
                {
                  order: 1,
                  name: "Disable Sections",
                  route: "/disable-section",
                  role: ["super_admin", "admin"],
                },
              ],
            },
            {
              order: 2,
              name: "InfoCards",
              children: [
                {
                  order: 1,
                  name: "Global Info Cards",
                  route: "/info-cards",
                  role: ["super_admin", "admin"],
                },
                {
                  order: 2,
                  name: "Products Info Cards",
                  route: "/products-info-cards",
                  role: ["super_admin", "admin"],
                },
              ],
            },
            {
              order: 2,
              name: "Similar-Products",
              route: "/similar-products",
              role: ["super_admin", "admin"],
            },
            {
              order: 4,
              name: "Cart Page",
              children: [
                {
                  order: 1,
                  name: "Cart-Similar-Products",
                  route: "/cart-similar-product",
                  role: ["super_admin", "admin"],
                },
              ],
            },
          ]
        },
        {
          order: 4,
          name: "Filters",
          route: "/filters",
          role: ["super_admin", "admin"],
        },
        {
          order: 6,
          name: "Notifications",
          children: [
            {
              order: 1,
              name: "Android Notification",
              route: "/andriodNotification",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "IOS Notification",
              route: "/iosNotification",
              role: ["super_admin", "admin"],
            },
          ],
        },
        {
          order: 7,
          name: "Zenim Wear",
          children: [
            {
              order: 1,
              name: "Hero Video",
              route: "/womens-wear/zenim-wear/hero-video",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "Secondary Video",
              route: "/womens-wear/zenim-wear/secondary-video",
              role: ["super_admin", "admin"],
            },
            {
              order: 3,
              name: "Story Grid",
              route: "/womens-wear/zenim-wear/story-grid",
              role: ["super_admin", "admin"],
            },
            {
              order: 4,
              name: "Style Inspiration",
              route: "/womens-wear/zenim-wear/style-inspiration",
              role: ["super_admin", "admin"],
            },
          ],
        },
        {
          order: 8,
          name: "Blissterry",
          children: [
            {
              order: 1,
              name: "Hero Video",
              route: "/womens-wear/blissterry/hero-video",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "Spotlight",
              route: "/womens-wear/blissterry/spotlight",
              role: ["super_admin", "admin"],
            },
            {
              order: 3,
              name: "Style Inspiration",
              route: "/womens-wear/blissterry/style-inspiration",
              role: ["super_admin", "admin"],
            },
          ],
        },
      ],
    },
    {
      order: 2,
      name: "Men's Wear",
      icon: <i className="bx bx-store"></i>,
      children: [
        {
          order: 1,
          name: "Mens Header Banner",
          route: "/mens-wear/mens-header-banner",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Main Banners",
          route: "/mens-wear/banners",
          role: ["super_admin", "admin"],
        },
        {
          order: 1,
          name: "Categories",
          route: "/mens-wear/categories",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Announcement Bar",
          route: "/mens-wear/announcement-bar",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Secondary Widgets",
          children: [
            {
              order: 1,
              name: "Secondary Widget-1",
              route: "/mens-wear/secondaryWidgetOne",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "Secondary Widget-2",
              route: "/mens-wear/secondaryWidgetTwo",
              role: ["super_admin", "admin"],
            },
            {
              order: 3,
              name: "Secondary Widget-3",
              route: "/mens-wear/secondaryWidgetThree",
              role: ["super_admin", "admin"],
            },
          ],
        },
        {
          order: 2,
          name: "Deal Widget",
          route: "/mens-wear/deal-widget",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Use Case Widget",
          route: "/mens-wear/use-case-widget",
          role: ["super_admin", "admin"],
        },
        {
          order: 3,
          name: "Sections",
          route: "/mens-wear/sections",
          role: ["super_admin", "admin"],
        },
      ],
    },
    {
      order: 3,
      name: "Common Settings",
      icon: <i className="bx bx-cog"></i>,
      children: [
        {
          order: 1,
          name: "Global-Discount-Percentage",
          route: "/global-discount-percentage",
          role: ["super_admin", "admin"],
        },
        {
          order: 2,
          name: "Express Delivery Fees",
          route: "/express-delivery-fees",
          role: ["super_admin", "admin"],
        },
        {
          order: 3,
          name: "Coupons",
          children: [
            {
              order: 1,
              name: "Coupons",
              route: "/coupons",
              role: ["super_admin", "admin"],
            },
            {
              order: 2,
              name: "Marketing Line",
              route: "/marketing-line",
              role: ["super_admin", "admin"],
            },
          ]
        },
        {
          order: 4,
          name: "Picture in Picture",
          route: "/pip",
          role: ["super_admin", "admin"],
        },
        {
          order: 5,
          name: "Expected Delivery Date Buffer Days",
          route: "/edd-buffer-days",
          role: ["super_admin", "admin"],
        },
        {
          order: 6,
          name: "App Version",
          route: "/app-version",
          role: ["super_admin", "admin"],
        },
        {
          order: 7,
          name: "GoKwik Toggle",
          route: "/gokwik-toggle",
          role: ["super_admin", "admin"],
        },
        {
          order: 8,
          name: "Clear Cache",
          route: "/clear-cache",
          role: ["super_admin", "admin"],
        },
        {
          order: 9,
          name: "Order Success Banner",
          route: "/order-success-banner",
          role: ["super_admin", "admin"],
        },
      ],
    },
  ],
};

const format = (item) => {
  if (item.role && item.role.some((name) => name === role)) {
    return item;
  }
  if (item.role) return null;
  item.children = item.children
    .map((ele) => {
      return format(ele);
    })
    .filter((element) => element);
  if (item.children.length) return item;
  return null;
};
Object.keys(leftNavigation).forEach((nav) => {
  leftNavigation[nav] = leftNavigation[nav]
    .map((item) => {
      return format(item);
    })
    .filter((ele) => ele);
  if (!leftNavigation[nav].length) {
    delete leftNavigation[nav];
  }
});

export default leftNavigation;
